import React from 'react';

/**
 * Two-word text logo with independent weights, fallback defaults,
 * and custom font family selection (including 'inherit' option).
 */
export const LogoWordmark = ({ logo, className = 'font-heading text-xl md:text-2xl tracking-tight', testid }) => {
  const l = logo || {};
  const w1 = l.word1 ?? 'FEDYK';
  const w2 = l.word2 ?? 'Furniture';

  // Если шрифт не выбран — возвращаем undefined для наследования стилей сайта
  const getFont = (fontName) => {
    if (!fontName || fontName === 'inherit') return undefined;
    return fontName.includes(' ') ? `"${fontName}", sans-serif` : `${fontName}, sans-serif`;
  };

  return (
    <span className={className} data-testid={testid}>
      {/* Первое слово */}
      <span 
        className={l.word1_bold ? 'font-semibold' : 'font-light'}
        style={l.word1_font ? { fontFamily: getFont(l.word1_font) } : undefined}
      >
        {w1}
      </span>
      
      {/* Второе слово */}
      {w2 ? (
        <span 
          className={l.word2_bold ? 'font-semibold' : 'font-light'}
          style={l.word2_font ? { fontFamily: getFont(l.word2_font) } : undefined}
        >
          {' '}{w2}
        </span>
      ) : null}
    </span>
  );
};

export default LogoWordmark;
